import { InputField } from "components/designV2/inputfield/inputfield";
import React, { useState, useEffect } from "react";
import { normalizeNumber } from "web-apps/company/components/common/number.normalize.logic";
import {
  PassSettingControl,
  PassSettingControls,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const PercentageInput: React.FC<{
  value: number;
  onChange: (v: number) => void;
  min: number;
  max: number;
  title: string;
  info: string;
}> = ({ value, onChange, min, max, title, info }) => {
  const [str, setStr] = useState(value.toString());
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) setStr(value.toString());
  }, [isEditing, value]);

  const normalizeValue = (input: string): number => {
    const numberValue = normalizeNumber(input);
    const normalizedValue = numberValue == null ? min : numberValue;

    return Math.min(
      max,
      Math.max(min, Math.round(normalizedValue * 100) / 100),
    );
  };

  const handleChange = (input: string): void => {
    setStr(input);
    onChange(normalizeValue(input));
  };

  const commit = () => {
    const v = normalizeValue(str);
    setStr(v.toFixed(2));
    onChange(v);
    setIsEditing(false);
  };

  return (
    <SystemSettingRow
      title={title}
      description={info}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <InputField
            ariaLabel={title}
            value={str}
            type="number"
            size="compact"
            maxLength={6}
            onChange={handleChange}
            onFocus={() => setIsEditing(true)}
            onBlur={commit}
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
